import { GameEvent, OperatorEvent } from "../interfaces/theos.interface";
import { LogLevel, log } from "../utils/log";
import { IPostMessageApi } from "../interfaces/postMessageApi.interface";

/**
 * Processes inbound and outbound messages (if they need adapting), and uses handshakes to pick the API
 */

let activeApi: IPostMessageApi | undefined = undefined;

// Any apis waiting for hanshake - if one receives a valid answer, it is set as the active API and the others are removed
const waitingForHandshake: IPostMessageApi[] = [];

/**
 * @internal
 * Attempt a handshake
 */
export const addSupportedApi = (api: IPostMessageApi): void =>
{
    if (activeApi !== undefined) {
        // We already have an API that has gone through handshake
        return;
    }

    waitingForHandshake.push(api);
};

/**
 * @internal
 * Converts inbound messages to FEIM format
 */
export const processInbound = (message: {readonly [key: string]: unknown}): {feimOpEvent: OperatorEvent; payload?: {}} | undefined =>
{
    if (activeApi !== undefined) {
        return activeApi.processInbound(message);
    }

    waitingForHandshake.some((adapter) =>
    {
        if (adapter.checkHandshake(message)) {
            waitingForHandshake.length = 0;
            activeApi = adapter;
            log(activeApi.name + " set as active", LogLevel.INIT);
            return true;
        }
        return false;
    });

    return undefined;
};

/**
 * @internal
 * Converts outbound messages to adapter format
 */
export const processOutbound = (event: GameEvent, payload: unknown): {[index: string]: unknown} | undefined =>
{
    if (activeApi !== undefined) {
        return activeApi.processOutbound(event, payload);
    }

    return {feimGameEvent: event, payload};
};